<template>
    <div>
        <!-- <div class="col-md-12">
            <boton-atras :nombre_ruta="'Participaciones-Federales-Municipios'"/>
        </div> -->
        <h1 class="titulo-uno">Sistema de Consulta de las Participaciones Fiscales Federales entregadas a Municipios de Chiapas</h1>
        <div class="w-100 d-flex justify content center">
            <iframe class="w-100" width="600" height="430" :src="urlServe+'rendicion-ctas/recursos-mpios/consulta/frmBusca-RM.asp'"></iframe>
        </div>

    </div>
</template>
<script>
import botonAtras from "../../button-atras";
export default {
  components: { botonAtras},

}
</script>
